import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { SelectModule } from 'primeng/select';
import { Subscription } from 'rxjs';
import { Franchise } from 'src/app/models/franchise.model';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { FormsModule } from '@angular/forms';
import { AddRole, PermRole } from '@/models/user-data.model';
import { OfficesService } from '@/services/api/franchises.service';
import { RolesService } from '@/services/api/roles.service';

@Component({
    selector: 'app-add-role-form',
    imports: [
        CommonModule,
        SelectModule,
        CardModule,
        ButtonModule,
        FormsModule
    ],
    template: `
    <div class="grid m-0 p-0">
    <div class="col-12 m-0 p-0">
        <div>
            <div class="p-fluid p-formgrid grid">
                <div class="field col-12 md:col-4">
                    <label htmlFor="office">Office</label>
                    <p-select id="office" [options]="offices" [(ngModel)]="selectedFranchise" optionLabel="Title" (onChange)="onSelectFranchise($event.value)"
                        placeholder="Select an Office" />
                </div>
                <div class="field col-12 md:col-4">
                    <label htmlFor="role">Role</label>
                    <p-select id="role" [options]="filteredRoles" [(ngModel)]="selectedRole" optionLabel="RoleName" (onChange)="onSelectRole($event.value)"
                        placeholder="Select a Role" />
                </div>
                <div class="field col-12 md:col-4">
                    <p-card *ngIf="selectedRole" class="no-c-padding" [header]="roleDisplay?.RoleName">
                            <ul class="list-none mx-0 mb-1 mt-1 p-0" *ngIf="roleDisplay && roleDisplay.Access">
                                <li class="flex align-items-start p-1" *ngFor="let permission of roleDisplay.Access">
                                    <span class="inline-flex mr-3 align-items-center justify-content-center bg-green-500 text-white border-circle border-1 surface-border" style="width:20px;height:20px">
                                        <i class="pi pi-check" style="font-size: 0.5rem"></i>
                                    </span>
                                    <span class="text-500 line-height-2" style="font-size: 1rem">{{renderPermDesc(permission.table, permission.perms)}}</span>
                                </li>
                            </ul>
                            <div class="flex justify-content-center">
                                <p-button (onClick)="onAddRole()" pRipple icon="pi pi-plus" label="Add Role" class="p-button-rounded" severity="success" [disabled]="!selectedRole || !selectedFranchise"/>
                            </div>
                    </p-card>
                </div>
            </div>
        </div>
    </div>
</div>
    `,
    standalone: true
})
export class AddRoleFormComponent implements OnChanges  {
  roleDisplay: any;
  @Input() resetFormTrigger: boolean = false;
  rolesSubscription!: Subscription;
  selectedFranchise: Franchise | null = null;
  selectedRole: PermRole | null = null;
  filteredRoles: PermRole[] = [];
  @Output() addRole = new EventEmitter<{role:PermRole,addRole:AddRole}>();

  constructor(
    private franchiseService: OfficesService,
    public rolesService: RolesService
  ) {
  }

  resetForm() {
    this.selectedFranchise = null;
    this.selectedRole = null;
    this.filteredRoles = [];
    this.roleDisplay = null;
  }

  get offices() {
    return this.franchiseService.getFilteredOffices('Users', 'View').sort((a, b) => a.CityCode.localeCompare(b.CityCode))
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['resetFormTrigger'] && changes['resetFormTrigger'].currentValue) {
      this.resetForm();
    }
  }

  filterRolesByFranchise(fid: number | null) {
    console.log('filtering roles by franchise', fid);
    console.log('roles', this.rolesService.roles());
    this.filteredRoles = this.rolesService.roles().filter(role => role.FID === fid);
  }

  onSelectFranchise(franchise: Franchise) {
    // const fid = franchise.FID === 5 ? null : franchise.FID;
    const fid = franchise.FID;
    this.selectedFranchise = franchise;
    this.selectedRole = null;
    this.filterRolesByFranchise(fid);
  }

  onSelectRole(role: PermRole) {
    this.selectedRole = role;
    this.roleDisplay = this.getRoleAccessList(role);
  }

  camelCaseToTitleCase(camelCase: string): string {
    return camelCase
      .replace(/([A-Z])/g, ' $1') // Add space before capital letters
      .replace(/^./, str => str.toUpperCase()); // Capitalize the first letter
  }

  convertToList(perms: string[]): string {
    if (perms.length === 0) return '';
    if (perms.length === 1) return perms[0];
    return perms.slice(0, -1).join(', ') + ' & ' + perms[perms.length - 1];
  }

  renderPermDesc(table:string, perms: string[]) {
    const tableString = this.camelCaseToTitleCase(table);
    const permString = this.convertToList(perms);
    return `Can ${permString} ${tableString}`;
  }

  onAddRole() {
    const output = {
      role: this.selectedRole!,
      addRole: {
        PermRoleID: this.selectedRole!.PermRoleID,
      FID: this.selectedFranchise!.FID,
      inviteRequired: false,
      RoleName: this.selectedRole!.RoleName
      }
    }
    this.addRole.emit(output);
    this.selectedRole = null;
  }

  getRoleAccessList(permRole: PermRole) {
    const roleName = permRole.RoleName || "Unknown Role";
    const accessMap = new Map<string, string[]>();
  
    permRole.RoleAccess?.forEach(access => {
      const table = access.AccessPermissions.dataTable;
      const perm = access.AccessPermissions.permType;
      if (!accessMap.has(table)) {
        accessMap.set(table, []);
      }
      accessMap.get(table)!.push(perm);
    });
  
    const accessArray = Array.from(accessMap.entries()).map(([table, perms]) => ({
      table,
      perms
    }));

    console.log(accessArray);
  
    return {
      RoleName: roleName,
      Access: accessArray
    };
  }

}
